export enum WorkingHoursEndpoint {
  Compartment = '/compartment',
  WorkingHours = '/working-hours',
  Dock = '/dock',
}
